import axios from "axios";
import { isEmpty } from "lodash";
// import accessToken from "./jwt-token-access/accessToken";

// const token = accessToken;
const storedAuthData = localStorage.getItem("authData");
const userName = storedAuthData ? JSON.parse(storedAuthData) : null;

console.log(userName,"userName")

const userNameDetails = !isEmpty(userName) ? userName : "";

const userInfoDetails = userNameDetails ? userNameDetails.token : "";

//apply base url for axios

const api = axios.create({
  // baseURL: "https://Mequalsapi.mequalsvps.in/api",
  baseURL: "https://imsapi.mequalsvps.in/api",
  // baseURL: "http://localhost:5050/api",
});

api.defaults.headers.common["Authorization"] = `Bearer ${userInfoDetails}`;
export function setAuthToken(authToken) {
  api.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
}

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;

export async function get(url, config = {}) {
  return await api.get(url, { ...config }).then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return api
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return api
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await api.delete(url, { ...config }).then((response) => response.data);
}
